/**
 * INTERNAL — dynamic gateway session fetch. Do not import from app/pages/components.
 */
import { authGetRequest, unwrapAuthMeUser } from "../../api/authClient";
import {
  mergeApplicationsOntoSessionUser,
  normalizeSessionEndpoint,
} from "../../utils/matchesAssignedApplicationOrigin";
import type { AuthSessionUser } from "./authSession.types";

export type SessionGatewayResponse = {
  raw: unknown;
  user: AuthSessionUser;
};

export async function fetchSessionByGatewayEndpoint(
  endpoint: string,
  options?: { bearer?: string },
): Promise<SessionGatewayResponse> {
  const path = normalizeSessionEndpoint(endpoint.trim());
  if (!path) {
    throw new Error("Missing session endpoint");
  }
  const res = await authGetRequest(path, undefined, { bearer: options?.bearer });
  const user = unwrapAuthMeUser(res) as AuthSessionUser | null;
  if (!user) {
    throw new Error("Invalid session response");
  }
  mergeApplicationsOntoSessionUser(user, res);
  return { raw: res, user };
}
